"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementPaymentStatus = void 0;
var SettlementPaymentStatus;
(function (SettlementPaymentStatus) {
    SettlementPaymentStatus["PENDING"] = "Pending";
    SettlementPaymentStatus["READY_FOR_PAYMENT"] = "Ready for Payment";
    SettlementPaymentStatus["PAID"] = "Paid";
    SettlementPaymentStatus["UNPAID"] = "Unpaid";
})(SettlementPaymentStatus || (exports.SettlementPaymentStatus = SettlementPaymentStatus = {}));
//# sourceMappingURL=SettlementPaymentStatus.js.map